import { PagebuilderMaxContentWidthOptions } from 'cms/constants/pagebuilder'

import { theme } from 'shared/ui/utils/designTokens'

import {
  PagebuilderDescriptionViewModel,
  PagebuilderHeadingViewModel} from './types'

export const resolveMaxContentWidth = (
  heading: PagebuilderHeadingViewModel | PagebuilderDescriptionViewModel
): string => {
  if (heading.maxContentWidth === PagebuilderMaxContentWidthOptions.full) {
    return '100%'
  }

  if (
    typeof heading.maxContentWidth === 'number' &&
    heading.maxContentWidth > 0
  ) {
    return `${heading.maxContentWidth}px`
  }

  return `${theme.dimensions.pageMaxWidthCondensed}px`
}

export const mergeSettingsWithDefaults = <T extends object>(
  settings: T | undefined,
  defaults: Partial<T>
): T => {
  const mergedSettings = { ...(settings ?? {}) } as T

  for (const key of Object.keys(defaults) as Array<keyof T>) {
    if (mergedSettings[key] === undefined && defaults[key] !== undefined) {
      mergedSettings[key] = defaults[key]
    }
  }

  return mergedSettings
}

export const getAssetDimensions = (
  asset: unknown,
  fallback: { width: number; height: number }
) => {
  const dimensions = (
    asset as {
      metadata?: { dimensions?: { width?: number; height?: number } }
    }
  )?.metadata?.dimensions

  if (
    typeof dimensions?.width === 'number' &&
    dimensions.width > 0 &&
    typeof dimensions?.height === 'number' &&
    dimensions.height > 0
  ) {
    return { width: dimensions.width, height: dimensions.height }
  }

  return fallback
}
